<template>
    <base-layout page-default-back-link="/home" showUserSettings="true" showSettings="true">

        <div class="ion-padding-top">
            <div class="flex justify-content-space-between ion-margin-top relative">
                <div class="absolute full-width line"></div>
                <div
                    class="flex flex-column justify-content-center full-width"
                    v-for="(slide, index) in slides"
                    :key="slide"
                >
                    <span
                    class="
                        flex flex-column
                        align-items-center
                        justify-content-center
                        align-self-center
                        bold
                        text-medium
                        radius
                    "
                    :style="{
                        background:
                        slide === currentSlide
                            ? 'var(--ion-color-success)'
                            : 'var(--ion-color-light-shade)',
                        color:
                        slide === currentSlide
                            ? 'var(--ion-color-light)'
                            : 'var(--ion-color-dark)',
                        width: '30px',
                        height: '30px',
                    }"
                    >
                    {{ index + 1 }}
                    </span>
                    <span
                    :style="{
                        color:
                        slide === currentSlide
                            ? 'var(--ion-color-success)'
                            : 'var(--ion-color-dark)',
                    }"
                    class="
                        flex
                        text-medium
                        bold
                        ion-margin-vertical
                        align-self-center
                    "
                    >
                    {{ slide }}
                    </span>
                </div>
            </div>

            <div v-if="currentSlide === 'Visitor'">

                <Visitor @go_to_second="go_to_items" ref="visitor" />

            </div>

            <div v-if="currentSlide === 'Items'" >

                <Search @go_to_first="go_to_visitor" @go_to_third="go_to_complete_visit" ref="search" />
            </div>

            <div v-if="currentSlide === 'Finish'" >

                <CompleteVisit @go_to_second="go_to_items" @visit_completed="visit_completed" ref="completeVisit" />
            </div>
        </div>

    </base-layout>
</template>

<script>
import Visitor from '../components/new_visit/Visitor.vue';
import Search from '../components/new_visit/Search.vue'
import CompleteVisit from '../components/new_visit/CompleteVisit.vue'

export default {
    components: { Visitor, Search, CompleteVisit },

    data(){
        return {
            slides: ["Visitor", "Items", "Finish"],
            slidesOpts: {
                            allowTouchMove: false,
                            autoHeight: true,
                        },
            currentSlide : "Visitor",

        }
    },

    methods: {
        go_to_visitor(){
            this.currentSlide = "Visitor"
        },

        go_to_items(){
            this.currentSlide = "Items"
        },

        go_to_complete_visit(){
            this.currentSlide = "Finish"
        },

        visit_completed(){
            this.$router.push({ name:'Home' });
        }
    },

    // beforeMount(){
    //     console.log('beforeMount NewVisit ')
    //     this.$store.commit('visits/setCurrentVisitId', { flvis_id:0 });
    //     this.currentSlide = 'Visitor';
    // },

    ionViewDidEnter() {
        console.log('New Visit page did enter');

        let visitFlag = this.$store.getters["visits/getVisitFlag"];
        console.log('Visit flag '+visitFlag);

        this.currentSlide = 'Visitor';

        if(visitFlag==1){
            this.$store.commit('visits/deleteVisitFlag'); // Raise the flag, so NewVisit loads the data.
            visitFlag = this.$store.getters["visits/getVisitFlag"];
            console.log('Is flag down: '+visitFlag)
            this.$refs.visitor.fillFields();
        } else {
            // empty store
            this.$store.commit('visits/setCurrentVisitId', { flvis_id:0 });
            this.$store.commit('visits/emptySelectedItems');

            this.$refs.visitor.emptyFields(); // Empty the fields of Visitor.
            //this.$refs.search.emptyFields(); // Empty the fields of Search.
            this.$refs.completeVisit.emptyFields(); // Empty the fields of CompleteVisit.
        }
    }
}
</script>

<style scoped>

    .flex {
        display: flex;
    }

    .full-width {
        width: 100% !important;
    }

    .absolute {
        position: absolute;
    }

    .relative {
        position: relative;
    }

    .align-self-center {
        align-self: center;
    }

    .align-self-end {
        align-self: flex-end;
    }

    .justify-content-center {
        justify-content: center;
    }

    .justify-content-space-around {
        justify-content: space-around;
    }

    .justify-content-space-evenly {
        justify-content: space-evenly;
    }

    .justify-content-space-between {
        justify-content: space-between;
    }

    .justify-content-space-end {
        justify-content: flex-end;
    }

    .align-items-center {
        align-items: center;
    }

    .flex-column {
        flex-direction: column;
    }

    .flex-center {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        height: 100%;
    }

    .text-tiny {
        font-size: 11px !important;
    }

    .text-small {
        font-size: 12px !important;
    }

    .text-medium {
        font-size: 14px !important;
    }

    .text-normal {
        font-size: 16px !important;
    }

    .text-large {
        font-size: 24px !important;
    }

    .text-xlarge {
        font-size: 36px !important;
    }

    .text-xxlarge {
        font-size: 48px !important;
    }

    .radius {
        border-radius: 8px !important;
    }

    .divider {
        background: var(--ion-color-light);
        margin: 8px 0;
        height: 1px;
        width: 100%;
    }

    .bold {
        font-weight: bold;
    }

    ion-item {
    --border-color: var(--ion-color-light-tint);
    }

    ion-item {
    --padding-start: 0;
    }

    .line {
        height: 3px;
        background: var(--ion-color-light-shade);
        top: 14px;
        z-index: -1;
    }

</style>